import { render, staticRenderFns } from "./EventCanceledAlert.vue?vue&type=template&id=7541980d"
import script from "./EventCanceledAlert.vue?vue&type=script&lang=js"
export * from "./EventCanceledAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports